import kmzFile from '../queryBuilder/KMZFile.json';

export default {
  name: 'queryBuilder',
  data() {
    return {
      dataAccess: null,
      jsonData: kmzFile,
      infoData: [],
      totalMorePolygones: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20, 50, 100],
      queryText: '',
      queryMultiPolygon: '',
      segmentedQuerys: [],
      segmentedMultiplePoligons: [],
      totalData: 0,
      actualIterator: 0,
    };
  },
  created() {
    this.dataAccess = this.$store.getters.dataAccess;
    this.readJson();
  },
  methods: {
    readJson() {
      this.jsonData.features.forEach((dataZone) => {
        const properties = dataZone.properties;
        const onlyPoligons = dataZone.geometry.geometries.filter((geometry) => geometry.type === 'Polygon');
        const maxLength = Math.max(...onlyPoligons.map((geometry) => geometry.coordinates[0].length));
        this.infoData.push({
          name: dataZone.properties.name,
          totalPolygons: onlyPoligons.length,
          maxLength: maxLength,
        });
        this.infoData = this.infoData.sort((a, b) => {
          if (a.name < b.name) return -1; // Si 'a' va antes que 'b', lo ordena antes
          if (a.name > b.name) return 1; // Si 'a' va después que 'b', lo ordena después
          return 0; // Si son iguales, no cambia el orden
        });
        if (onlyPoligons.length > 1) {
          this.totalMorePolygones += 1;
        }
        if (properties && onlyPoligons) {
          this.buildQuery(properties, onlyPoligons);
        }
      });
    },
    copyQuery() {
      navigator.clipboard
        .writeText(this.segmentedMultiplePoligons[this.actualIterator])
        .then(() => {
          console.log('Texto copiado al portapapeles.');
        })
        .catch((err) => {
          console.error('Error al copiar el texto: ', err);
        });
    },
    nextIterator() {
      if (this.totalData - 1 >= this.actualIterator) {
        this.actualIterator += 1;
      }
    },
    preIterator() {
      if (0 <= this.actualIterator) {
        this.actualIterator -= 1;
      } else {
        this.actualIterator = this.totalData;
      }
    },
    buildQuery(properties, geometries) {
      const name = properties.name ? properties.name : '';
      const firstPoint = geometries[0].coordinates[0][0];
      const lat = properties.Cent_Lat != null && properties.Cent_Lat != '' ? properties.Cent_Lat : firstPoint[1];
      const lon = properties.Cent_Long != null && properties.Cent_Long != '' ? properties.Cent_Long : firstPoint[0];
      if (geometries.length == 1) {
        this.queryText += `
            WITH first_insert AS (
                INSERT INTO core.address (street, city, state,id_country,lat,lon)
                VALUES ('${name}','','',45,${lat},${lon})
                RETURNING id
            )`;
        this.queryText += `
            , second_insert AS (
                INSERT INTO core.spot (id_client, id_address, type, name, description)
                VALUES (2611,(SELECT id FROM first_insert), 'Cliente', '${name}', 'Ubicación generado a partir de archivo KMZ')
                RETURNING id
            )`;
        geometries[0].coordinates[0].forEach((point, index) => {
          if (index == 0) {
            this.queryText += `
                    INSERT INTO core.zone (id_spot, radio, lat, lon)
                    VALUES ((SELECT id FROM second_insert), 0, ${point[1]}, ${point[0]})`;
          } else {
            this.queryText += `
                    ,((SELECT id FROM second_insert), 0, ${point[1]}, ${point[0]})`;
          }
        });
        this.queryText += ';';
        this.segmentedQuerys.push(this.queryText);
      } else {
        this.queryMultiPolygon += `
            WITH first_insert AS (
                INSERT INTO core.address (street, city, state,id_country,lat,lon)
                VALUES ('${name}','','',45,${lat},${lon})
                RETURNING id
            )`;
        this.queryMultiPolygon += `
            , second_insert AS (
                INSERT INTO core.spot (id_client, id_address, type, name, description)
                VALUES (2611,(SELECT id FROM first_insert), 'Cliente', '${name}', 'Ubicación generado a partir de archivo KMZ')
                RETURNING id
            ),`;
        //const firstPoint = geometries[0].coordinates[0][0];
        this.queryMultiPolygon += `
            polygon_data AS (
                SELECT	ST_ConcaveHull(ST_Collect(pol), 0.99, true) AS merged_polygon,
                        ST_ConcaveHull(ST_Collect(pol), 0.99, true)::geography AS ver_dbeaver,
                        st_centroid(ST_ConcaveHull(ST_Collect(pol), 0.99, true)) AS polygon_center
                FROM(`;
        geometries.forEach((polygon, index) => {
          if (index == 0) {
            this.queryMultiPolygon += `
                SELECT
                ST_MakePolygon(ST_MakeLine(
                ARRAY[
                `;
          } else {
            this.queryMultiPolygon += `
                UNION ALL SELECT
                ST_MakePolygon(ST_MakeLine(
                ARRAY[
                `;
          }
          let arrayPoints = [];
          polygon.coordinates[0].forEach((point) => {
            arrayPoints.push(`ST_MAKEPOINT(${point[0]}, ${point[1]})`);
          });
          this.queryMultiPolygon += arrayPoints.join(',');
          this.queryMultiPolygon += `])) as pol`;
        });
        this.queryMultiPolygon += `) as foo),`;
        this.queryMultiPolygon += `
            polygon_points AS (
                SELECT
                    (ST_DumpPoints(merged_polygon)).geom AS point_geom
                FROM polygon_data
            ),
            point_coordinates AS (
                SELECT
                    ST_Y(point_geom) AS lat,
                    ST_X(point_geom) AS lon
                FROM polygon_points
            )
            INSERT INTO core.zone (lat, lon, radio, id_spot)
            SELECT lat,lon, 0, (SELECT id FROM second_insert)
            FROM point_coordinates;
            `;
        this.segmentedMultiplePoligons.push(this.queryMultiPolygon);
        this.queryMultiPolygon = '';
      }
      this.totalData = this.segmentedMultiplePoligons.length;
    },
  },
  computed: {
    kmzInfo() {
      const common = {
        class: 'text-left',
        tdClass: 'small',
      };
      return [
        {
          key: 'name',
          label: 'Nombre zona',
          sortable: true,
          ...common,
        },
        {
          key: 'totalPolygons',
          label: 'Total de poligonos de la zona',
          sortable: true,
          ...common,
        },
        {
          key: 'maxLength',
          label: 'Maximo total de puntos de un poligono dentro de la zona',
          sortable: true,
          ...common,
        },
      ];
    },
  },
  watch: {},
};
